"use client";

import { createContext, useContext } from "react";

interface QuickReplyContextValue {
  /** Sends a visible user message; metadata travels with it (e.g. a send confirmation). */
  sendMessage: (text: string, metadata?: Record<string, unknown>) => void;
}

const QuickReplyContext = createContext<QuickReplyContextValue | null>(null);

export const QuickReplyProvider = QuickReplyContext.Provider;

export function useQuickReply() {
  return useContext(QuickReplyContext);
}
